(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-carrinho-sugestoes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-sugestoes')) {
    customElements.define(
      'mm-sugestoes',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.aoClicar);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.aoClicar);
        }

        aoClicar = (evento) => {
          const pilula = evento.target.closest('.mm-sug__pilula');
          if (pilula) return this.escolhe(pilula);
          const botao = evento.target.closest('[data-add]');
          if (botao) return this.adiciona(botao);
        };

        dados(item, seletor) {
          try {
            return JSON.parse(item.querySelector(seletor).textContent);
          } catch {
            return null;
          }
        }

        escolhe(pilula) {
          const item = pilula.closest('[data-item]');
          const opcao = Number(pilula.dataset.opcao);
          pilula.parentElement.querySelectorAll('.mm-sug__pilula').forEach((p) => {
            p.setAttribute('aria-pressed', p === pilula ? 'true' : 'false');
          });

          const escolha = this.dados(item, '[data-padrao]') || [];
          item.querySelectorAll('.mm-sug__pilula[aria-pressed="true"]').forEach((p) => {
            escolha[Number(p.dataset.opcao)] = p.dataset.valor;
          });
          escolha[opcao] = pilula.dataset.valor;

          const variantes = this.dados(item, '[data-variantes]') || [];
          const v = variantes.find((x) => x.o.every((valor, i) => valor === escolha[i]));
          const botao = item.querySelector('[data-add]');
          const rotulo = botao.querySelector('[data-rotulo]');
          if (v && v.d) {
            botao.dataset.variantId = v.id;
            botao.disabled = false;
            rotulo.textContent = 'Adicionar';
            item.querySelector('[data-preco]').textContent = v.f;
          } else {
            botao.disabled = true;
            rotulo.textContent = 'Esgotado';
          }
        }

        async adiciona(botao) {
          if (this.ocupado) return;
          this.ocupado = true;
          this.setAttribute('aria-busy', 'true');
          const rotulo = botao.querySelector('[data-rotulo]');
          rotulo.textContent = 'Adicionando...';
          const aviso = this.querySelector('[data-aviso]');
          aviso.hidden = true;

          const secao = this.closest('cart-items-component')?.dataset.sectionId;
          try {
            const resposta = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(botao.dataset.variantId), quantity: 1 }],
                sections: secao,
                sections_url: window.location.pathname,
              }),
            });
            const corpo = await resposta.json();
            if (!resposta.ok) throw new Error(corpo.description || 'cart-add');

            let carrinho = null;
            try {
              carrinho = await (await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } })).json();
            } catch {
              carrinho = null;
            }

            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: carrinho,
                  sourceId: 'mm-sugestoes',
                  data: {
                    source: 'mm-sugestoes',
                    itemCount: carrinho ? carrinho.item_count : 0,
                    sections: corpo.sections,
                  },
                },
              })
            );
          } catch {
            rotulo.textContent = 'Adicionar';
            aviso.textContent = 'Não deu para adicionar agora. Tente de novo.';
            aviso.hidden = false;
          } finally {
            this.ocupado = false;
            this.removeAttribute('aria-busy');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-carrinho-topo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-presente-auto')) {
    customElements.define(
      'mm-presente-auto',
      class extends HTMLElement {
        static observedAttributes = ['data-acao'];

        connectedCallback() {
          this.agir();
        }

        attributeChangedCallback() {
          if (this.isConnected) this.agir();
        }

        async agir() {
          const acao = this.dataset.acao;
          if (!acao || acao === 'nada' || window.__mmPresenteOcupado) return;
          // o redesenho da gaveta chama de novo; não repete a mesma ação em seguida
          const chave = acao + ':' + this.dataset.variante;
          if (window.__mmPresenteUltima === chave && Date.now() - (window.__mmPresenteQuando || 0) < 4000) return;
          window.__mmPresenteUltima = chave;
          window.__mmPresenteQuando = Date.now();
          window.__mmPresenteOcupado = true;

          const secao = this.closest('cart-items-component')?.dataset.sectionId;
          const id = Number(this.dataset.variante);
          const pedido = acao === 'por'
            ? { url: this.dataset.addUrl, corpo: { items: [{ id, quantity: 1 }] } }
            : { url: this.dataset.changeUrl, corpo: { id: String(id), quantity: acao === 'um' ? 1 : 0 } }; // change.js só aceita o id como texto
          if (secao) {
            pedido.corpo.sections = secao;
            pedido.corpo.sections_url = window.location.pathname;
          }
          try {
            const resposta = await fetch(pedido.url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(pedido.corpo),
            });
            const dados = await resposta.json();
            if (!resposta.ok) return;
            let carrinho = null;
            try {
              carrinho = await (await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } })).json();
            } catch {
              carrinho = null;
            }
            // com a gaveta fechada, o presente entra sem abrir a gaveta na cara da cliente
            const gaveta = document.querySelector('cart-drawer-component');
            const aberta = Boolean(gaveta?.querySelector('dialog')?.open);
            const abreSozinha = gaveta?.hasAttribute('auto-open');
            if (gaveta && !aberta && abreSozinha) gaveta.removeAttribute('auto-open');
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: carrinho,
                  sourceId: 'mm-presente',
                  data: { source: 'mm-presente', itemCount: carrinho ? carrinho.item_count : 0, sections: dados.sections },
                },
              })
            );
            if (gaveta && !aberta && abreSozinha) gaveta.setAttribute('auto-open', '');
          } catch {
            /* sem rede: tenta de novo no próximo redesenho */
          } finally {
            window.__mmPresenteOcupado = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-menu-gaveta"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-menu')) {
    customElements.define(
      'mm-menu',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.aoClicar);
          this.gaveta = this.closest('details');
          this.gaveta?.addEventListener('toggle', this.aoAlternar);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.aoClicar);
          this.gaveta?.removeEventListener('toggle', this.aoAlternar);
        }

        aoClicar = (evento) => {
          const abrir = evento.target.closest('[data-abrir]');
          if (abrir) return this.mostra(abrir.dataset.abrir);
          if (evento.target.closest('[data-voltar]')) this.mostra('raiz');
        };

        // fechou a gaveta: na próxima vez ela abre no painel principal
        aoAlternar = () => {
          if (!this.gaveta.open) setTimeout(() => this.mostra('raiz', false), 400);
        };

        mostra(id, foco = true) {
          const atual = this.querySelector('.mm-menu__painel.is-ativo');
          const novo = this.querySelector(`.mm-menu__painel[data-painel="${id}"]`);
          if (!novo || novo === atual) return;
          atual?.classList.remove('is-ativo');
          atual?.setAttribute('inert', '');
          novo.classList.add('is-ativo');
          novo.removeAttribute('inert');
          this.querySelectorAll('[data-abrir]').forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.abrir === id)));
          this.closest('.menu-drawer')?.scrollTo({ top: 0 });
          if (!foco) return;
          const alvo = id === 'raiz' ? this.querySelector(`[data-abrir="${atual?.dataset.painel}"]`) : novo.querySelector('[data-voltar]');
          alvo?.focus({ preventScroll: true });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
